import { createFeatureSelector, createSelector } from '@ngrx/store';

import * as fromLive from '@live/reducers';

export const selectLiveEdgeState = createFeatureSelector<fromLive.IState>(fromLive.liveFeatureKey);

export const selectLiveInsightsState = createSelector(selectLiveEdgeState, state => state.builtInInsights);

export const selectBuiltInInsights = createSelector(selectLiveInsightsState, state => state.builtInInsights);

export const isBuiltInInsightsLoaded = createSelector(selectLiveInsightsState, state => state.loaded);

export const hasError = createSelector(selectLiveInsightsState, state => state.error);
